import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSelector from '@/components/selectors/BaseSelector';

interface IntervalSelectorProps {
    value: number;
    onChange: (interval: number) => void;
    intervals?: number[];
    unit?: 'minutes' | 'days';
    label?: string;
}

const IntervalSelector = ({
    value,
    onChange,
    intervals = [5, 10, 15, 30],
    unit = 'minutes',
    label
}: IntervalSelectorProps) => {
    const { t } = useTranslation();

    const intervalItems = useMemo(() => intervals.map((val) => ({ value: val, text: val.toString() })), [intervals]);

    const displayLabel = label ?? `${t('interval')} (${t(unit)})`;

    return (
        <BaseSelector
            value={value}
            items={intervalItems}
            itemText="text"
            itemValue="value"
            label={displayLabel}
            onChange={(val) => onChange(val as number)}
        />
    );
};

export default IntervalSelector;
